import { Link } from "react-router-dom";

/* Общая вёрстка юридических страниц (/privacy, /terms). Юридический текст не
   маркетинг: правила тона лендинга на него не распространяются. */

export const P = ({ children, className = "" }) => (
  <p className={`max-w-[640px] text-base text-muted ${className}`}>{children}</p>
);

export const Li = ({ children }) => <li className="max-w-[640px] pl-1 text-base text-muted">{children}</li>;

export const A = ({ href, children, external = true }) => (
  <a
    href={href}
    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    className="text-white underline underline-offset-4 transition-colors duration-300 ease-smooth hover:text-accent"
  >
    {children}
  </a>
);

export const Part = ({ n, title, children, first = false }) => (
  <section className={first ? "mt-12" : "mt-12 border-t border-ink-4 pt-12"}>
    <h2 className="text-xl font-semibold sm:text-2xl">
      <span className="mr-3 align-middle font-mono text-sm text-accent">{n}</span>
      {title}
    </h2>
    <div className="mt-4 space-y-4">{children}</div>
  </section>
);

export const LegalPage = ({ title, meta, children }) => (
  <main id="main" className="min-h-screen">
    <div className="mx-auto w-full max-w-3xl px-4 py-16 sm:px-6 sm:py-20">
      <Link
        to="/"
        className="inline-block text-sm text-muted transition-colors duration-300 ease-smooth hover:text-white"
        data-testid="legal-back-link"
      >
        ← На главную
      </Link>
      <h1 className="mt-10 max-w-[680px] text-3xl font-semibold sm:text-4xl">{title}</h1>
      <p className="mt-4 font-mono text-sm text-muted">{meta}</p>
      {children}
    </div>
  </main>
);
